<template>
    <div>
      <el-form-item label="正文" class="exr-type-subject">
        <el-radio-group v-model="config.subject">
          <el-radio-button label="line">单行</el-radio-button>
          <el-radio-button label="text">多行</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="元素">
        <el-checkbox border v-model="config.subjectPinyin" label="有拼音"></el-checkbox>
        <el-checkbox border v-model="config.image" label="有图片"></el-checkbox>
        <el-checkbox border v-model="config.audio" label="有音频"></el-checkbox>
        <el-checkbox border v-model="config.audioText" label="有音频原文"></el-checkbox>
      </el-form-item>
      <el-form-item label="空格数量">
        <el-input-number v-model="config.minBlankCount" :min="1" title="最小数量"></el-input-number>
        —
        <el-input-number v-model="config.maxBlankCount" :min="0" title="最多数量，0表示不限制"></el-input-number>
      </el-form-item>
      <el-form-item label="选项">
        <el-checkbox border v-model="config.itemsPinyin" label="有拼音"></el-checkbox>
        <el-checkbox border v-model="config.itemsAudio" label="有音频"></el-checkbox>
      </el-form-item>
      <el-form-item label="选项数量">
        <el-input-number v-model="config.minItemsCount" :min="1" title="最小数量"></el-input-number>
        —
        <el-input-number v-model="config.maxItemsCount" :min="0" title="最多数量，0表示不限制"></el-input-number>
      </el-form-item>
      <el-form-item label="答案音频">
        <el-switch v-model="config.answerAudio"></el-switch>
      </el-form-item>
      <el-form-item label="答题解析">
        <el-checkbox border v-model="config.showReviewsContent" label="内容说明"></el-checkbox>
        <el-checkbox border v-model="config.showReviewsGrammar" label="关联语法"></el-checkbox>
      </el-form-item>
      <el-form-item label="AI超解析">
        <el-radio-group v-model="config.aiChao">
          <el-radio-button :label="0">没有小超</el-radio-button>
          <el-radio-button :label="1">有小超没有解析</el-radio-button>
          <el-radio-button :label="2">有小超有解析</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="翻译按钮">
        <el-checkbox border v-model="config.translatable.subject" label="题干可翻译" :false-label="0" :true-label="1"></el-checkbox>
        <el-checkbox border v-model="config.translatable.audioText" label="音频文本可翻译" :false-label="0" :true-label="1"></el-checkbox>
        <el-checkbox border v-model="config.translatable.answers" label="正确答案可翻译" :false-label="0" :true-label="1"></el-checkbox>
      </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'xctk',
  data () {
    return {
      config: {
        subject: 'line',
        subjectPinyin: true,
        image: true,
        audio: true,
        audioText: false,
        itemsPinyin: true,
        itemsAudio: false,
        minItemsCount: 2,
        maxItemsCount: 0,
        minBlankCount: 2,
        maxBlankCount: 0,
        answerAudio: true,
        showReviewsContent: false,
        showReviewsGrammar: false,
        aiChao: 2,
        translatable: {},
      }
    }
  }
}
</script>